import { render, staticRenderFns } from "./EditExpertRemarkModal.vue?vue&type=template&id=6a8b187e&scoped=true"
import script from "./EditExpertRemarkModal.vue?vue&type=script&lang=js"
export * from "./EditExpertRemarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b187e",
  null
  
)

export default component.exports